import SidebarItem from './SidebarItem'

interface SidebarNavigationProps {
  currentPath: string
}

export default function SidebarNavigation({ currentPath }: SidebarNavigationProps) {
  const navigationItems = [
    {
      href: '/company-info',
      label: 'Company Info',
    },
    {
      href: '/projects',
      label: 'Projects',
    },
    {
      href: '/employees',
      label: 'Employees',
    }
  ]

  return (
    <div className="space-y-2">
      {navigationItems.map((item) => (
        <SidebarItem
          key={item.href}
          href={item.href}
          active={currentPath === item.href}
        >
          {item.label}
        </SidebarItem>
      ))}
    </div>
  )
} 